var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('ArtesVisuais',{attrs:{"title":"Resultado das Matriculas dos Classificados","subtitle":"Vestibular 2020 - EAD","course":"Artes Visuais"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }